<div class="dialog">
    <div class="dialog-header">
        <h3>{{ 'SALES_DOCUMENT|Pozycja dodatkowa' | translate }}</h3>

        <button 
            iccIconButton 
            (click)="close()"
            appearance="flat"
        >
            <icc-icon name="close"></icc-icon>
        </button>

    </div>
    <div class="dialog-body">

        <table>
            <tbody>
                <tr *ngFor="let product of data.products">
                    <td >{{product?.name}}</td>
                    <td class="dialog-actions" >
                        <button (click)="addProduct(product.id)" iccIconButton appearance="flat">
                            <icc-icon name="add"></icc-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

    </div>
    <div class="dialog-footer">
        <span class="space"></span>
        <button 
            iccButton 
            (click)="close()"
        >
            <icc-icon name="close"></icc-icon>
            {{ 'INTERFACE|Anuluj' | translate}}
        </button>
    </div>
</div>

<div 
    class="curtain"
    (click)="close()"
></div>